<template>
    <div class="binding">
        <header class="binding__header">
            <img class="logo" src="@/assets/img/flypig.svg" alt="">
        </header>
        <!-- {{ log }} -->
        <div v-if="isBindingSuccess || bindingPhone">
            <div class="binding__success" >
                <img src="@/assets/img/icon/success_done.svg" alt="">
            </div>
            <div v-if="isBindingSuccess" class="binding__title binding__title--success">
                綁定成功
            </div>
            <div v-else class="binding__title binding__title--success">
                已綁定手機
            </div>
            <div v-if="bindingPhone" class="binding__phone">
                已成功綁定 {{ bindingPhone }}
            </div>
        </div>
        <div v-else>
            <div class="binding__title">
                綁定手機
            </div>
            <div class="binding__landlord-wrap">
                <div class="input-group select-list phone" :class="{error: error.landlord.phoneErr}">
                    <div class="input-group-prepend" @click="clickEvent">
                        <span data-id="886" class="input-group-text" > 
                            台灣＋886
                            <img class="dropdown-img" src="@/assets/img/icon/arrow_down_black.svg" alt="">
                        </span>
                        <ul v-if="dropDownShow">
                            <li>
                                台灣＋886
                            </li>
                        </ul>
                    </div>
                    <input class="phone-num" required name="phone" placeholder="電話號碼" type="text" v-bind:class="{ error: error.landlord.phoneErr, confirm: landlord.phone }" v-model="landlord.phone">
                    <!-- <img class="cancel-img" v-show="landlord.phone" @click="clearAccount" src="@/assets/img/icon/input_clear_all.svg" alt=""> -->
                    <span v-show="error.landlord.phoneErr" class="error-with-btm">{{error.landlord.phoneErr}}</span>
                </div>
                <div class="verify-code">
                    <div class="group">
                        <input class="default-input" required name="verifyCode" placeholder="驗證碼" type="text" maxlength="6" v-bind:class="{confirm: landlord.verifyCode, error: error.landlord.verifyCodeErr}" v-model="landlord.verifyCode">
                        <div v-if="timer==0" class="count-down-btn" @click="landlordRegister(), timer = 60, countDown(), $analytics.logEvent('綁定頁_送出取得驗證碼', { screen_name: '綁定頁_送出取得驗證碼'})" >獲取驗證碼</div>
                        <div v-else class="count-down-btn">簡訊已發送 {{timer}}</div>
                        <span v-show="error.landlord.verifyCodeErr" class="error-with-btm">{{error.landlord.verifyCodeErr}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            landlord: {
                nationalityCode: '886',
                phone: null,
                verifyCode: null,
            },
            error: {
                landlord: {
                    phoneErr: null,
                    verifyCodeErr: null,
                },
            },
            dropDownShow: 0,
            timer: 0,
            isBindingSuccess: false,
            bindingPhone: null,
            profile: null,
            log: [],
        };
    },
    mounted() {
        this.log.push('mounted')
        this.log.push('liffId', '2006589442-0kbVZ7qB')
        liff.init({liffId: '2006589442-0kbVZ7qB'})
        .then(()=>{
            console.log(liff)
            this.log.push('liff init')
            this.checkBinding()
        }).catch((err) => {
            this.log.push('liff err')
            // Error happens during initialization
            this.log.push(err.code, err.message);
        });
        let _this = this;
        let el = _this.$el;
        document.addEventListener('click', function (e) {
            if( el.contains(e.target) != true){
                _this.dropUp();
            }
        })
    },
    watch: {
        'landlord.phone': function (val) {
            let phoneReg = /^09[0-9]{8}$/;
            if( val.length > 0 ){
                if( this.landlord.nationalityCode == '886'){
                    let phone = this.phoneFormatTw(val)
                   if(!phoneReg.test(phone)) {
                        this.error.landlord.phoneErr = '格式錯誤';
                    }else{
                        this.error.landlord.phoneErr = '';
                    }
                }
            }else{
                this.error.landlord.phoneErr = '';
            }
        },
        'landlord.verifyCode': function (val) {
            this.error.landlord.verifyCodeErr = null
            if(val.length === 6){
                this.landlordLogin()
            }
        },
    },
    methods: {
        landlordRegister: function () {
            let account = this.phoneFormatTw(this.landlord.phone)
            let nationality_code = this.landlord.nationalityCode

            let data = {
                account,
                nationality_code
            }
            this.log.push('landlordRegister')
            this.log.push(data)
            this.$store.dispatch('landlordRegister',data).catch(err => {
                let alarm = {
                    status: true,
                    title: '系統發生未預期錯誤，請再試一次',
                    description: null,
                    type: 'error'
                }
                this.$store.dispatch('setAlarmStatus', alarm)
            })
        },
        landlordLogin: function () {
            let account = this.phoneFormatTw(this.landlord.phone)
            let verification_code = this.landlord.verifyCode
            let nationality_code = this.landlord.nationalityCode
            let data = {account, verification_code, nationality_code}
            this.log.push('landlordLogin')
            this.log.push(data)
            this.$store.dispatch('landlordLogin',data)
            .then((res)=> {
                this.log.push('landlordLogin success', res)
                this.bindingAccount()
            })
            .catch(err => {
                console.log('err',err)
                this.error.landlord.verifyCodeErr = err.data.errorMsg
            })
        },
        bindingAccount: function () {
            this.log.push('bindingAccount')
            this.log.push(liff.isLoggedIn())
            if (liff.isLoggedIn()) {
              this.log.push('liff isLoggedIn')
              liff.getProfile().then(profile=>{
                this.log.push('liff getProfile')
                this.log.push(profile)
                const data = {
                    lineUserId: profile.userId
                }
                this.log.push(data)
                this.$store.dispatch('landlordBinding',data)
                .then((res) => {
                    this.log.push('綁定成功', res)
                    console.log('綁定成功', res.data.result)
                    if(res.data.result == 'SUCCESS'){
                        this.isBindingSuccess = true
                        setTimeout(() => {
                            liff.closeWindow();
                        }, 2000)
                    }else{
                        let alarm = {
                            status: true,
                            title: res.data.errorMsg || '綁定失敗',
                            description: null,
                            type: 'error'
                        }
                        this.$store.dispatch('setAlarmStatus', alarm)
                    }
                }).catch(err => {
                    this.log.push('綁定失敗', err)
                })
              });
            }
            
        },
        checkBinding: function () {
            this.log.push('checkBinding')
            if (liff.isLoggedIn()) {
                this.log.push('liff isLoggedIn')
                liff.getProfile().then(profile=>{
                    const data = {
                        lineUserId: profile.userId
                    }
                    this.log.push('getProfile', data)
                    this.$store.dispatch('checkBinding', data).then((res) => {
                        this.log.push('checkBinding success', res)
                        if(res.data.result){
                            this.bindingPhone = res.data.result
                        }
                    }).catch(err => {
                        this.log.push('checkBinding err', err)
                    })
                });
            }
        },
        phoneFormatTw: function (phone) {
            if(phone.substr(0, 1) == '9' && phone.length == 9){
                return phone = '0' + phone;
            }else{
                return phone;
            }
        },
        clearAccount: function () {
            this.landlord.phone = null
            this.error.landlord.phoneErr = null
        },
        dropDown: function () {
            this.dropDownShow = 1;
        },
        dropUp: function () {
            this.dropDownShow = 0;
        },
        clickEvent: function () {
            let tag = event.target.tagName;
            // console.log(tag)
            if( tag == 'LI' ){
                this.dropUp();
            }else if( tag == 'DIV' || tag == 'SPAN' || tag == 'IMG'){
                this.dropDown()
            }
        },
        countDown: function () {
            var _self = this
            if (this.timer != 0){
                this.timer--;
                setTimeout(function() {
                    _self.countDown()
                },
                1000)
            }
        },
    }
};
</script>

<style scoped lang="scss">
.binding {
    &__header {
        text-align: center;
        padding: 5px;
        background: #ff9275;
        .logo {
            width: 40px;
            height: 40px;
        }
    }
    &__title {
        text-align: center;
        font-size: 20px;
        margin-top: 40px;
        margin-bottom: 24px;
        color: #ff9275;
        &--success {
            margin-top: 20px;
        }
    }
    &__phone {
        text-align: center;
        margin-top: 20px;
        font-size: 16px;
    }
    &__success {
        margin: 0 auto;
        text-align: center;
        margin-top: 40px;
        img {
            width: 40px;
            height: 40px;
        };
    }
    &__landlord-wrap{
        width: 250px;
        margin: 30px auto;
        .error-with-btm {
            position: absolute;
            bottom: -18px;
            font-size: 12px;
            color: #ff6868;
            right: 0;
        }
        .phone{
            position: relative;
            width: calc(100% - 4px);
            box-sizing: border-box;
            margin-bottom: 24px;
            border: solid 1px #d7d7d7;
            border-radius: 6px;
            height: 40px;
            .country-img{
                position: relative;
                margin-right: 4px;
            }
            input{
                width: 130px;
                height: 30px;
                padding: 0 0 0 43px;
            }
            .input-group-prepend {
                width: 100px;
                padding: 14px 9px 14px 8px;
            }
            .dropdown-img {
                right: 6px;
            }
            .cancel-img{
                position: absolute;
                right: 10px;
                cursor: pointer;
            }
            &.error {
                border: solid 1px #ff6868 !important;
            }
        }
        .verify-code{
            margin-bottom: 30px;
            height: 40px;
            .input-group {
                position: relative;
            }
            .group{
                position: relative;
                display: flex;
                align-items: center;
                input{
                    width: 136px;
                    margin-right: 12px;
                    text-align: center;
                    // height: 16px;
                }
                input:hover{
                    border: solid 1px #CACFCD;
                }
                input:focus-within{
                    border: solid 1px #676362;
                }
                .default-input {
                    width: 104px;
                    box-sizing: border-box;
                }
                .count-down-btn{
                    cursor: pointer;
                    width: 136px;
                    height: 40px;
                    border-radius: 4px;
                    background-color: #fff9f1;
                    color: #eb7859;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 500;
                    border: solid 1px #ffd9bf;
                }
            }
        }
    }
}

</style>


// WEBPACK FOOTER //
// src/pages/binding/index.vue